module.exports = __webpack_public_path__ + "img/how-it-works-mobile-mobile.f1645f93.png";